import { createSelector } from 'reselect'

import { selectDevicesInfoState } from './selectDevicesInfoState'

export const selectDevicesInfo = createSelector([selectDevicesInfoState], ({ data }) => data)
